import React from 'react';

/**
 * Checkbox de vinculação ao Canny (Sugestões de melhoria).
 * Layout do controle fica no pai (user-form-row).
 */
function CannyUserSection({ checked, onChange, disabled = false }) {
  return (
    <label className={`uc-upf-check user-form-uc-check${disabled ? ' is-disabled' : ''}`}>
      <input
        type="checkbox"
        className="uc-upf-check-native"
        checked={checked === true}
        disabled={disabled}
        onChange={(e) => {
          if (disabled) return;
          onChange(e.target.checked);
        }}
      />
      <span className="uc-upf-check-faux" aria-hidden="true" />
      <span className="uc-upf-check-txt">Este usuário poderá sugerir melhorias para o sistema Verve</span>
    </label>
  );
}

export default CannyUserSection;
